import React from 'react'
import { useTranslation } from 'react-i18next'
import { ToggleContainer, ToggleButton, ToolbarToggleContainer } from './PriceModeToggle.styles'
import { ViewToggleButton, ViewToggleLabel } from '../ViewToggle/ViewToggle.styles'
import type { PriceModeToggleProps, PriceMode } from './PriceModeToggle.types'

export const PriceModeToggle: React.FC<PriceModeToggleProps> = ({
  mode,
  onModeChange,
  className,
  disabled = false,
  variant = 'default',
  compact = false,
}) => {
  const { t } = useTranslation()

  const options: Array<{
    value: PriceMode
    labelKey: string
    shortLabelKey: string
  }> = [
    {
      value: 'monthly',
      labelKey: 'common.priceMode.monthly',
      shortLabelKey: 'common.priceMode.monthlyShort',
    },
    {
      value: 'yearly',
      labelKey: 'common.priceMode.yearly',
      shortLabelKey: 'common.priceMode.yearlyShort',
    },
  ]

  if (variant === 'toolbar') {
    return (
      <ToolbarToggleContainer className={className} $compact={compact}>
        {options.map((option) => {
          const active = mode === option.value
          return (
            <ViewToggleButton
              key={option.value}
              $active={active}
              onClick={() => onModeChange(option.value)}
              disabled={disabled}
              type="button"
              aria-pressed={active}
              aria-label={compact ? t(option.labelKey) : undefined}
            >
              <ViewToggleLabel $active={active}>
                {t(compact ? option.shortLabelKey : option.labelKey)}
              </ViewToggleLabel>
            </ViewToggleButton>
          )
        })}
      </ToolbarToggleContainer>
    )
  }

  return (
    <ToggleContainer className={className}>
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          $active={mode === option.value}
          onClick={() => onModeChange(option.value)}
          disabled={disabled}
          type="button"
        >
          {t(option.labelKey)}
        </ToggleButton>
      ))}
    </ToggleContainer>
  )
}
